import { ClientDashboardSalesDetailsDto } from '@hoqus/connectis-client-dashboard-types';
import { SalesType } from './SalesType.ts';

export const mapDtoToSalesType = (dto: ClientDashboardSalesDetailsDto): SalesType => ({
  phoneNumber: dto.phoneNumber,
  email: dto.email,
});
